<template>
    <div class="main-body">
        <cabecalho-padrao/>
        <div class="caixa-grid">
            <div class="lista" v-if="(carteiraSel == -1) || (sempreMostrarlistaContas)">
                <div class="menu">
                    <router-link to="/"><img src="../../assets/home.png"></router-link>
                </div>
                <h1>Minhas Contas</h1>
                <div class="grid-card"  v-for="conta in listaContas" :key="conta.id">                    
                    <div class="dados-conta">
                        <div class="linha">
                            <h2><a @click="Extrato(conta.id-1,false)">{{conta.Nome_carteira}}</a></h2>
                            <h2><a @click="Extrato(conta.id-1,false)">R${{formatarValor(conta.saldo)}}</a></h2>
                        </div>
                        <h3><a @click="Extrato(conta.id-1,false)">{{conta.descricao}}</a></h3>    
                    </div>
                    <button @click="Extrato(conta.id-1,false)" :class="{ active: pesquisa.cod_carteira === conta.Cod_carteira }">
                            <img src="../../assets/right-arrow-gray.png" >
                    </button>
                </div>
            </div>

            <div class="form-grid" v-if="carteiraSel>=0">
                <div class="wrapper">
                    <div class="header">
                        <div>
                            <h1>{{listaContas[carteiraSel].Nome_carteira}}</h1>
                            <h3>Extrato da conta</h3>
                        </div>
                        <button @click="MudarConta()"><img src="../../assets/close.png"></button>
                    </div>
                    <div class="pagecontrol">
                        <div class="wrapper-filtro">
                            <div>
                                <div class="filtro">
                                    <div class="custom-select-wrapper">
                                        <span class="icon"><img src="../../assets/calendar.png" alt="calendario"></span>                            
                                        <select v-model="pesquisa.filtroPeriodo" id="filtroPeriodo" class="custom-select"  @change="Extrato(carteiraSel,false)">
                                            <option value="mes_atual">Mês: {{nomeMesAtual}}</option>
                                            <option value="ultimos_30">Últimos 30 dias</option>
                                            <option value="ultimos_6m">Últimos 6 meses</option>
                                            <option value="periodo">Período</option>
                                        </select>
                                        <!-- Inputs só aparecem se "Período" for escolhido -->
                                        <div v-if="pesquisa.filtroPeriodo === 'periodo'" class="periodo-inputs">
                                            <input type="date" v-model="pesquisa.DtInicial" class="input-date" @change="Extrato(carteiraSel,false)"/>
                                            <input type="date" v-model="pesquisa.DtFinal" class="input-date" @change="Extrato(carteiraSel,false)"/>

                                        </div>                                    
                                    </div>
                                </div>
                                <div class="paginacao">
                                    <label> Pagina: {{paginaAtual}} de {{qtdePagina}} </label>
                                    <button @click="Paginacao(-1)"><img src="../../assets/left-arrow-gray.png"></button>
                                    <button @click="Paginacao(1)"><img src="../../assets/right-arrow-gray.png"></button>
                                </div>
                            </div>
                            <div class="totais">
                                <h2>Saldo R${{saldoAtual}}</h2>
                            </div>
                        </div> 
                        <section class="grid-large">
                            <div class="grid-colunas">
                                <div v-for="col in colunas" :key="col.field" class="grid-col"  :style="col.style">
                                    {{col.label}}
                                </div>
                            </div>
                            <div class="grid-colunas -conteudo" v-for="lin in listaExtrato" :key="lin.id">
                                <div v-for="col in colunas" :key="col.field" class="grid-col -conteudo"  :style="col.style">                       
                                    <div v-if="col.field=='acao'">
                                        ...
                                    </div>   
                                    <div  v-else-if="col.field=='Valor'">                                    
                                        <span v-if="lin.Debito>0" class="-cor-vermelho">{{ formatarColuna(lin,col.field)}}</span>
                                        <span v-else class="-cor-verde">{{ formatarColuna(lin,col.field)}}</span>
                                    </div>     
                                    <div  v-else-if="col.field=='Simbolo'">                                    
                                        <span v-if="lin.Debito>0" class="-cor-vermelho">{{ formatarColuna(lin,col.field)}}</span>
                                        <span v-else class="-cor-verde">{{ formatarColuna(lin,col.field)}}</span>
                                    </div>                                                                       
                                    <div v-else>                               
                                        {{ formatarColuna(lin,col.field)}}
                                    </div>   
                                </div>                              
                            </div>
                        </section>
                        <section class="grid-thin">
                            <div class="grid-card" v-for="lin in listaExtrato" :key="lin.id">
                                <div class="card-linha">
                                    <div>
                                        Data: {{formatarColuna(lin,'Data_andamento')}}
                                    </div>
                                    <div>                                      
                                        <div>                                    
                                            <span v-if="lin.Debito>0" class="-cor-vermelho">{{ formatarColuna(lin,'Valor')}} {{ formatarColuna(lin,'Simbolo')}}</span>
                                            <span v-else class="-cor-verde">{{ formatarColuna(lin,'Valor')}} {{ formatarColuna(lin,'Simbolo')}}</span>
                                        </div>    
                                    </div> 
                                </div>                                      

                                <div>
                                    {{formatarColuna(lin,'Historico')}}
                                </div>                                
   
                                                                                  
                            </div>
                        </section>
                        
                    </div>

                </div>
                               
            </div>


        </div>

    </div>
</template>


<script>
import CabecalhoPadrao from '../../components/Cabecalho.vue';
import api from '../../services/api.js';

export default {
  name: 'Mais',
  components:{
    'cabecalho-padrao': CabecalhoPadrao
  },
  data: () => ({
        listaContas:[],
        listaExtrato:[],
        paginaAtual:1,
        qtdePagina:1,
        nomeMesAtual: "Set/2025",        
        saldoAtual: 0,
        carteiraSel:-1,
        sempreMostrarlistaContas:false,
        pesquisa:{
            filtroPeriodo: "mes_atual",
            DtInicial: '',
            DtFinal: '',
            limitIni: 0,
            limitFim: 20,
            cod_carteira: 0
        },
        colunas:[
            {field:'Data_andamento', label:'Data',  style: 'flex:1; min-width: 80px;'},
            {field:'Historico',label:'Descrição',  style: 'flex:5; min-width: 400px;'},
            {field:'Valor',label:'Valor',  style: 'flex:1; min-width: 90px; text-align: right;'},
            {field:'Simbolo',label:'',  style: 'flex:1; min-width: 10px;'},            
            {field:'Saldo',label:'Saldo',style: 'flex:1; min-width: 90px; text-align: right;'},
            {field:'acao',label:'AÇÃO',style: 'flex:1; min-width: 50px;'},
        ]        
    
    }),
  methods: {
        Novo(){
            this.$router.push('/caixa/novo');
        },
        MudarConta(){
            this.pesquisa.cod_carteira=0;
            this.listaExtrato=[];
            this.carteiraSel = -1;
        },
        formatarValor(v){
            var format = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2});                                    
            return format.format(v);
        },        
        formatarColuna(data,field){
            if (field=='Saldo'){
                return 'R$'+this.formatarValor(data['Saldo']);
            } 
            if (field=='Valor'){
                let valor = '';
                if (data['Debito'] > 0)      
                    valor =  this.formatarValor(data['Debito'])
                else         
                    valor =  this.formatarValor(data['Credito'])               
                return 'R$'+valor;
            }                     
            if (field=='Simbolo'){
                let valor = '';
                if (data['Debito'] > 0)      
                    valor =  '-'
                else         
                    valor =  '+'                
                return valor;
            }                                       
            return data[field];
        },
        async Paginacao(soma){
            if ((this.paginaAtual+soma)<1)
                this.paginaAtual = 1
            else 
            if ((this.paginaAtual+soma)>this.qtdePagina)
                this.paginaAtual = this.qtdePagina
            else{
                this.paginaAtual = this.paginaAtual+soma;
                this.Extrato(this.carteiraSel,true);
            }

            
        },         
        async PegarContas() {
            try {
                let url = `caixa/listar`;
   
                const response = await api.get(url); // Aguarda a resposta da API
                this.resposta = response.data.qry;
                console.log(response);


                this.listaContas = response.data.qry;
            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
        },  
        async Extrato(id,Paginacao){
            try {
                this.carteiraSel = id;
                if (id>=0){
                    

                    if (this.pesquisa.filtroPeriodo=="mes_atual") {
                        const hoje = new Date();
                        const ano = hoje.getFullYear();
                        const mes = String(hoje.getMonth() + 1).padStart(2, '0');

                        this.pesquisa.DtInicial = `${ano}-${mes}-01`;
                        const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
                    
                        const dia = String(lastDay.getDate()).padStart(2, '0');
                        this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;   
                    }
                    else
                    if (this.pesquisa.filtroPeriodo=="ultimos_30") {
                        const hoje = new Date();
                        let ano = hoje.getFullYear();
                        let mes = String(hoje.getMonth() + 1).padStart(2, '0');    
                        let dia = String(hoje.getDate()).padStart(2, '0');                

                        this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;                       

                        // Data inicial = hoje - 30 dias
                        const dataInicial = new Date();
                        dataInicial.setDate(dataInicial.getDate() - 30);
                        ano = dataInicial.getFullYear();
                        mes = String(dataInicial.getMonth() + 1).padStart(2, '0');    
                        dia = String(dataInicial.getDate()).padStart(2, '0');                         

                        this.pesquisa.DtInicial = `${ano}-${mes}-${dia}`;           

                    }
                    else
                    if (this.pesquisa.filtroPeriodo=="ultimos_6m") {
                        const hoje = new Date();
                        let ano = hoje.getFullYear();
                        let mes = String(hoje.getMonth() + 1).padStart(2, '0');    
                        let dia = String(hoje.getDate()).padStart(2, '0');                

                        this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;                       

                        // Data inicial = hoje - 180 dias
                        const dataInicial = new Date();
                        dataInicial.setDate(dataInicial.getDate() - 180);
                        ano = dataInicial.getFullYear();
                        mes = String(dataInicial.getMonth() + 1).padStart(2, '0');    
                        dia = String(dataInicial.getDate()).padStart(2, '0');                         

                        this.pesquisa.DtInicial = `${ano}-${mes}-${dia}`;           

                    }


                    if (Paginacao==false){
                        this.pesquisa.limitIni = 0;
                        this.pesquisa.limitFim = 20;
                        this.paginaAtual = 1;
                    }
                    else{
                        this.pesquisa.limitIni = 20*(this.paginaAtual-1);
                        this.pesquisa.limitFim = 20;
                    }
                    
                    this.pesquisa.cod_carteira = this.listaContas[id].Cod_carteira;
                    const response = await api.post('caixa/extrato',this.pesquisa); // Aguarda a resposta da API
                    this.saldoAtual = response.data.saldo;
                    this.qtdeRegistros  = response.data.count;
                    this.listaExtrato = response.data.qry;
                    console.log(response);

                    this.qtdePagina = Math.round(this.qtdeRegistros/20);
                    if (this.qtdePagina<(this.qtdeRegistros/20))
                        this.qtdePagina = this.qtdePagina+1;
                }


            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
        }        

    },    
    computed: {
             
    },
    async created(){
        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, '0');

        this.pesquisa.DtInicial = `${ano}-${mes}-01`;
        const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        const dia = String(lastDay.getDate()).padStart(2, '0');
        this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;   

        this.nomeMesAtual =  hoje.toLocaleString("pt-BR", { month: "short" }).toUpperCase()+'/'+ano;

        this.sempreMostrarlistaContas = true;
        if (window.screen.availWidth<1300) 
            this.sempreMostrarlistaContas = false;

        await this.PegarContas();

        await this.Extrato(-1,false);        
    }
}
</script>

<style>
  @import '../../css/components/sub-menu-body.css';
  @import '../../css/components/caixa-grid.css';
  @import '../../css/components/form-grid.css';

</style>        